import { Archive } from '../../../models/Archive/Archive.js';

class Archiving {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get() {
    return this.apiClient.get('/v1/shipments/settings/archive').then(response => Archive.createFromResponse(response.data));
  }
  put(arc) {
    return this.apiClient.put('/v1/shipments/settings/archive', arc.getUpdatePayload()).then(response => Archive.createFromResponse(response.data));
  }
}

export { Archiving };
//# sourceMappingURL=Archiving.js.map
